export default __webpack_public_path__ + "static/media/ecoFootprint.5dcdf4ff.png";